module.exports = __webpack_public_path__ + "img/message-check-square.96dedea3.svg";